import React, { useState } from 'react';
import './participant-information.scss';

// Components
// ---------------------
import { Clickbox } from '../../components/clickbox/clickbox';
import { ParticipantDocuments } from './subpages/participant-documents/participant-documents.jsx';
import { TechnicalSpecifications } from './subpages/technical-specifications/technical-specifications.jsx';
import { ReferenceData } from './subpages/reference-data/reference-data.jsx';
import { DelayedMarketData } from './subpages/delayed-market-data/delayed-market-data.jsx';

export const ParticipantInformation = ({ ...props }) => {
  const [tabs, setTabs] = useState([
    {
      label: 'Participant Documents',
      content: <ParticipantDocuments />,
      active: true,
    },
    { label: 'Technical Specifications', content: <TechnicalSpecifications /> },
    { label: 'Reference Data', content: <ReferenceData /> },
    { label: 'Delayed Market Data', content: <DelayedMarketData /> },
  ]);

  const handleTabClick = (e, index) => {
    setTabs(
      tabs.map((tab, i) => {
        if (i === index) {
          if (!tab.active) {
            tab.active = true;
          }
        } else {
          tab.active = false;
        }
        return tab;
      })
    );
  };
  return (
    <div className="participant-information-page">
      <div className="clickbox-selector">
        {tabs.map((item, i) => {
          return (
            <Clickbox
              text={item.label}
              aria={`View ${item.label}`}
              isExpanded={item.active}
              className={item.active ? 'active' : 'inactive'}
              onClick={(e) => handleTabClick(e, i)}
            />
          );
        })}
      </div>
      <div className="participant-information-content">
        {tabs.map((item, i) => {
          return (
            <div className={item.active ? '' : 'display-none'}>
              {item.content}
            </div>
          );
        })}
      </div>
    </div>
  );
};
